import { render, staticRenderFns } from "./My-account.vue?vue&type=template&id=31f915a4"
import script from "./My-account.vue?vue&type=script&lang=js"
export * from "./My-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports